import { createContext } from 'react';

const PDPStickyButtonsContext = createContext(null);

export default PDPStickyButtonsContext;
